import {
  //  Alert,
  // Card,
  Skeleton,
  Space,
  // TreeSelect,
  // Typography,
} from 'antd';

// import type { RangePickerProps } from 'antd/es/date-picker';
// import InfoIcon from 'assets/images/icon-info.svg';
// import PreviousClaimIcon from 'assets/images/previous-claim-icon.svg';
// import { CardTitle } from 'components/claimCard/CardTitle';
import {
  // FormDatePicker,FormTreeSelect,
  FormRadio,
  FormWrapper,
} from 'components/form';
import { useClaimPropertiesContext } from 'contexts/claimProperties';
import { useCachedClaimProperties, useKeycloakReady } from 'hooks';
// import moment from 'moment';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breakpoint } from 'styled-components-breakpoint';
// import { DEFAULT_DATE_FORMAT } from 'utils';
import { SelectedClaimTypeObjectType } from '../../hooks/useSelectedClaimTypeMapping';
// import { DiagnosisSelect } from './DiagnosisSelect';
// import { DoctorSelect } from './DoctorSelect';
// import { ClaimInfoCardUtils } from './utils';
import { Dispatch, SetStateAction, useCallback, useEffect, useRef } from 'react';
import { MemberRadioItem } from './MemberRadioItem';
import { useFormContext } from 'react-hook-form';
// import { useClaimTypesProperties } from 'all-in-one-shared-api';
// import { useProfileInfoContext } from 'contexts/profileInfo';
// import { ClaimTypesEnum } from '../../../claims/components/FilterSection/utils';

// const { TreeNode } = TreeSelect;
// const { Text } = Typography;

// eg __ABC, __EDF for sub node in claim type select
export const SUBNODE_PATTERN = /^__.{1,}/;

const Wrapper = styled.div`
  ${breakpoint('desktop')`
    width: 50%;
  `}
  display: grid;
  row-gap: 26px;
  margin-bottom: 20px;
`;

interface ClaimInfoCardProps {
  isEditClaim?: boolean;
  selectedClaimTypeObject: SelectedClaimTypeObjectType;
  hasPreviousClaim?: boolean;
  handleOnPreviousClaimClick?: () => void;
  setSelectedObject?: Dispatch<SetStateAction<Record<string, string> | undefined>>;
}

const ClaimInfoCard = ({
  isEditClaim,
  selectedClaimTypeObject,
}: // hasPreviousClaim,
// handleOnPreviousClaimClick,
ClaimInfoCardProps) => {
  const {
    t,
    // i18n
  } = useTranslation();
  const { watch, setValue } = useFormContext();
  const {
    tokenParsed,
    //  token, ready
  } = useKeycloakReady();

  const patientMemberType = watch('patientMemberType');
  const previousPatientMemberType = useRef(undefined);

  const { key: claimPropertiesKey } = useClaimPropertiesContext();
  const { data: claimProperties } = useCachedClaimProperties(claimPropertiesKey);
  // const { state: profileInfo } = useProfileInfoContext();

  // const {
  //   shouldFetch: shouldFetchClaimTypesProperties,
  //   data: claimTypesPropertiesData,
  //   isLoading: isClaimTypesLoading,
  // } = useClaimTypesProperties(
  //   {
  //     key: 'getClaimTypesProperties',
  //     params: {
  //       policyNumber: profileInfo?.policyNumber,
  //       memberId: profileInfo?.memberId,
  //       patientMemberType,
  //     },
  //   },
  //   token ?? '',
  //   profileInfo?.policyNumber ?? '',
  //   profileInfo?.memberId ?? '',
  //   patientMemberType,
  // );

  useEffect(() => {
    const defaultPatientType = claimProperties?.familyMembers?.find(
      (member) => member.memberType == tokenParsed?.memberType,
    );

    if (defaultPatientType && !patientMemberType) {
      setValue('patientMemberType', defaultPatientType.memberType);
    }
  }, [tokenParsed, claimProperties?.familyMembers, setValue, patientMemberType]);

  useEffect(() => {
    const selectedPatient = claimProperties?.familyMembers?.find((a) => a.memberType == patientMemberType);
    if (selectedPatient) {
      const name = [selectedPatient.firstName, selectedPatient.lastName].filter((n) => !!n).join(' ');
      setValue('patientName', name);
    }
  }, [patientMemberType, setValue, claimProperties]);

  // useEffect(() => {
  //   shouldFetchClaimTypesProperties(ready && profileInfo !== undefined && patientMemberType !== undefined);
  // }, [ready, patientMemberType, profileInfo, shouldFetchClaimTypesProperties]);

  const resetRelatedFieldsAfterChangePatient = useCallback(() => {
    if (previousPatientMemberType.current !== patientMemberType) {
      if (previousPatientMemberType.current !== undefined) {
        setValue('claimType', undefined);
        setValue('doctorId', undefined);
        setValue('doctorName', undefined);
        setValue('doctorNameQuery', undefined);
        setValue('diagnosisCode', undefined);
        setValue('claims', []);
        setValue('claimTypeObject', []);
      }
      previousPatientMemberType.current = patientMemberType;
    }
  }, [patientMemberType, setValue]);

  useEffect(() => {
    resetRelatedFieldsAfterChangePatient();
  }, [resetRelatedFieldsAfterChangePatient]);

  // const handleOnClaimTypeChange = (current: string, prev: string[]) => {
  //   if (!prev) {
  //     return [current];
  //   }

  //   if (current.match(SUBNODE_PATTERN)) {
  //     return [...prev.filter((o) => o.match(SUBNODE_PATTERN)), current];
  //   }

  //   return [current];
  // };

  // const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  //   if (!current) return false;

  //   const oneYearAgo = moment().subtract(1, 'years').subtract(1, 'days');
  //   return current.isAfter(moment().endOf('day')) || current.isBefore(oneYearAgo);
  // };

  return (
    // <Card
    //   id="claimInformation"
    //   // title={<CardTitle formStepIndex={1} title={t('newClaim.claimInfo.title')} />}
    // >
    <div>
      {selectedClaimTypeObject.isLoaded ? (
        <Wrapper>
          <FormWrapper
            name="patientMemberType"
            label={t('newClaim.start.patient')}
            secondaryText={t('newClaim.start.pleaseSelectThePatientForThisClaim')}
          >
            <FormRadio name="patientMemberType" disabled={isEditClaim}>
              <Space direction="vertical">
                {(claimProperties?.familyMembers ?? [])
                  .sort((a, b) => ((a.memberType ?? '0') > (b.memberType ?? '0') ? 1 : -1))
                  .map(({ memberType, firstName, lastName }) => (
                    <MemberRadioItem
                      key={memberType}
                      memberType={memberType}
                      firstName={firstName}
                      lastName={lastName}
                    />
                  ))}
              </Space>
            </FormRadio>
          </FormWrapper>
          {/* <FormWrapper
            name="claimTypeObject"
            label={t('newClaim.start.claimType')}
            {...(selectedClaimTypeObject.data.length > 1 && {
              secondaryText: t('newClaim.start.claimTypeDescription'),
              secondaryTextIcon: <img src={InfoIcon} alt="receiptsIcon" style={{ marginTop: '4px' }} />,
            })}
          >
            {claimTypesPropertiesData?.claimTypes && (
              <FormTreeSelect
                disabled={isEditClaim}
                name="claimTypeObject"
                multiple
                treeCheckable
                treeDefaultExpandAll
                showSearch={false}
                placeholder={t('newClaim.start.selectClaimType')}
                handleOnChange={handleOnClaimTypeChange}
                loading={isClaimTypesLoading}
              >
                {ClaimInfoCardUtils.formatClaimTypeData(claimTypesPropertiesData, i18n.language)?.map(
                  ({ code, description, benefits }) => {
                    if ((benefits || []).length > 0) {
                      return (
                        <TreeNode key={code} value={code || ''} title={description} disableCheckbox>
                          {benefits?.map(({ code: subCode, description: subDescription }) => (
                            <TreeNode
                              key={`__${subCode}` || ''}
                              value={`__${subCode}` || ''}
                              title={subDescription}
                              checkable
                            />
                          ))}
                        </TreeNode>
                      );
                    }
                    return <TreeNode key={code} value={code || ''} title={description} />;
                  },
                )}
              </FormTreeSelect>
            )}
          </FormWrapper>
          {hasPreviousClaim && (
            <Alert
              message={t('newClaim.claimInfo.duplicatedClaimInfo.info.title')}
              description={<Text type="secondary">{t('newClaim.claimInfo.duplicatedClaimInfo.info.description')}</Text>}
              type="warning"
              icon={<img src={PreviousClaimIcon} alt="PreviousClaimIcon" />}
              showIcon={true}
              onClick={handleOnPreviousClaimClick}
            />
          )} */}

          {/* <DoctorSelect selectedClaimTypeObject={selectedClaimTypeObject.data} />
          <DiagnosisSelect selectedClaimTypeObject={selectedClaimTypeObject.data} />*/}

          {/* <FormWrapper
            name="treatmentDate"
            label={t(
              ClaimInfoCardUtils.getTitleTreatmentBasedOnClaimType(
                selectedClaimTypeObject.data[0]?.code as ClaimTypesEnum,
              ),
            )}
            secondaryText={`${t('newClaim.start.partialClaim.infoTitle')} ${t(
              'newClaim.start.partialClaim.infoDescription',
            )}`}
            secondaryTextIcon={<img src={InfoIcon} alt="infoIcon" style={{ marginTop: '4px' }} />}
          >
            <FormDatePicker
              name="treatmentDate"
              placeholder={t('newClaim.claimInfo.treatmentDatePlaceholder')}
              format={DEFAULT_DATE_FORMAT}
              disabledDate={disabledDate}
            />
          </FormWrapper> */}
        </Wrapper>
      ) : (
        <Skeleton active />
      )}
    </div>
    // </Card>
  );
};

export default ClaimInfoCard;
